module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-wrapper showSweetAlert visible",
    attrs: {
      "data-custom-class": "",
      "data-has-cancel-button": "true",
      "data-has-confirm-button": "true",
      "data-allow-outside-click": "false",
      "data-has-done-function": "true",
      "data-animation": "pop",
      "data-timer": "null"
    }
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.isEditing ? 'Edit Additional Investment' : 'Add Funds to My Reinvestments'))]), _vm._v(" "), _c('p', {
    staticClass: "modal-paragraph"
  }, [_vm._v("\n        " + _vm._s(_vm.isEditing ? 'Update your additional investment details below.' : 'Select a note and enter the amount you want to add to your reinvestments.') + "\n      ")]), _vm._v(" "), (!_vm.isEditing) ? _c('div', {
    staticClass: "modal-info-box"
  }, [_c('p', {
    staticClass: "info-text"
  }, [_c('em', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n          You can add additional funds to your reinvestments between "), _c('strong', [_vm._v("45 and 3 days")]), _vm._v(" before the reinvestment date.\n          Only notes within this window are shown below.\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select note")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedNote),
      expression: "selectedNote"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "note",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedNote = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select note")]), _vm._v(" "), _vm._l((_vm.availableNotes), function(note, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": note
      }
    }, [_vm._v("\n              Note " + _vm._s(note.noteId) + " - Reinvests " + _vm._s(_vm.formatDate(note.maturityDate)) + "\n            ")])
  })], 2), _vm._v(" "), (!_vm.selectedNote) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n            Please select a note\n          ")]) : _vm._e()]), _vm._v(" "), (_vm.selectedNote) ? _c('div', [(_vm.fundingSources && _vm.fundingSources.length > 0) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select bank account")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFundingSource),
      expression: "selectedFundingSource"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "fundingSource",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFundingSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select bank account")]), _vm._v(" "), _vm._l((_vm.fundingSources), function(fs, index) {
    return _c('option', {
      key: index,
      attrs: {
        "disabled": fs.removed
      },
      domProps: {
        "value": fs
      }
    }, [_vm._v("\n                " + _vm._s(fs.name) + "\n              ")])
  })], 2), _vm._v(" "), (!_vm.selectedFundingSource) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n              Please select a bank account\n            ")]) : _vm._e()]) : _c('div', {
    staticClass: "alert alert-warning no-bank-account-alert"
  }, [_c('p', {
    staticClass: "no-bank-text"
  }, [_vm._v("\n              You must connect a bank account to make ACH transfers.\n              "), _c('router-link', {
    staticClass: "bank-link",
    attrs: {
      "to": {
        name: 'AddFundingSource'
      }
    }
  }, [_vm._v("\n                Add a bank account\n              ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text",
      "placeholder": "$0.00",
      "required": ""
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.amountError) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("\n              " + _vm._s(_vm.amountError) + "\n            ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-buttons"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg btn-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), (_vm.selectedNote) ? _c('button', {
    staticClass: "btn btn-info btn-lg btn-accept",
    attrs: {
      "type": "button",
      "disabled": !_vm.isFormValid || _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.submitAddMoney()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.loading ? 'Submitting...' : (_vm.isEditing ? 'Update Investment' : 'Add Money')) + "\n            ")]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-95985f14","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/AddMoney.vue
// module id = 2192
// module chunks = 1